import type { InventoryApi } from './inventory-api';
import { inventoryApi as mockInventoryApi } from './mock-inventory-api';
import { inventoryApi as liveInventoryApi } from './live-inventory-api';

/**
 * Single switch point between the deterministic mock (used by default, tests,
 * and CI) and the local live API server backed by the cloned database (see
 * server/ and scripts/clone-prod-data.sh). Set VITE_API_MODE=live in
 * .env.local and run `pnpm server` to use real cloned data locally.
 */
export const inventoryApi: InventoryApi =
  import.meta.env.VITE_API_MODE === 'live' ? liveInventoryApi : mockInventoryApi;
